export default __webpack_public_path__ + "static/media/download.2ed6adac.svg";